import "/__w/1/s/BotFramework-WebChat/packages/component/src/Icon/ComponentIcon.module_built.css";
const classes = {"icon--copy":"w61aa0a_icon--copy","icon--dismiss":"w61aa0a_icon--dismiss","direction--rtl":"w61aa0a_direction--rtl","icon--chevron":"w61aa0a_icon--chevron","icon--microphone":"w61aa0a_icon--microphone","icon--unchecked-circle":"w61aa0a_icon--unchecked-circle","direction--follow":"w61aa0a_direction--follow","icon--thumb-down":"w61aa0a_icon--thumb-down","icon--checkmark-circle":"w61aa0a_icon--checkmark-circle","icon--view-code":"w61aa0a_icon--view-code","icon--send":"w61aa0a_icon--send","icon--attachment-checkmark":"w61aa0a_icon--attachment-checkmark","icon--thumb-down-filled":"w61aa0a_icon--thumb-down-filled","component-icon":"w61aa0a_component-icon","icon--copy-code":"w61aa0a_icon--copy-code","icon--attachment":"w61aa0a_icon--attachment","appearance--text":"w61aa0a_appearance--text","icon--copy-code-checkmark":"w61aa0a_icon--copy-code-checkmark","icon--thumb-up":"w61aa0a_icon--thumb-up","icon--thumb-up-filled":"w61aa0a_icon--thumb-up-filled","icon--download":"w61aa0a_icon--download"}
export default classes

const _icon__copy0 = classes["icon--copy"]
export { _icon__copy0 as "icon--copy" }

const _icon__dismiss0 = classes["icon--dismiss"]
export { _icon__dismiss0 as "icon--dismiss" }

const _direction__rtl0 = classes["direction--rtl"]
export { _direction__rtl0 as "direction--rtl" }

const _icon__chevron0 = classes["icon--chevron"]
export { _icon__chevron0 as "icon--chevron" }

const _icon__microphone0 = classes["icon--microphone"]
export { _icon__microphone0 as "icon--microphone" }

const _icon__unchecked_circle0 = classes["icon--unchecked-circle"]
export { _icon__unchecked_circle0 as "icon--unchecked-circle" }

const _direction__follow0 = classes["direction--follow"]
export { _direction__follow0 as "direction--follow" }

const _icon__thumb_down0 = classes["icon--thumb-down"]
export { _icon__thumb_down0 as "icon--thumb-down" }

const _icon__checkmark_circle0 = classes["icon--checkmark-circle"]
export { _icon__checkmark_circle0 as "icon--checkmark-circle" }

const _icon__view_code0 = classes["icon--view-code"]
export { _icon__view_code0 as "icon--view-code" }

const _icon__send0 = classes["icon--send"]
export { _icon__send0 as "icon--send" }

const _icon__attachment_checkmark0 = classes["icon--attachment-checkmark"]
export { _icon__attachment_checkmark0 as "icon--attachment-checkmark" }

const _icon__thumb_down_filled0 = classes["icon--thumb-down-filled"]
export { _icon__thumb_down_filled0 as "icon--thumb-down-filled" }

const _component_icon0 = classes["component-icon"]
export { _component_icon0 as "component-icon" }

const _icon__copy_code0 = classes["icon--copy-code"]
export { _icon__copy_code0 as "icon--copy-code" }

const _icon__attachment0 = classes["icon--attachment"]
export { _icon__attachment0 as "icon--attachment" }

const _appearance__text0 = classes["appearance--text"]
export { _appearance__text0 as "appearance--text" }

const _icon__copy_code_checkmark0 = classes["icon--copy-code-checkmark"]
export { _icon__copy_code_checkmark0 as "icon--copy-code-checkmark" }

const _icon__thumb_up0 = classes["icon--thumb-up"]
export { _icon__thumb_up0 as "icon--thumb-up" }

const _icon__thumb_up_filled0 = classes["icon--thumb-up-filled"]
export { _icon__thumb_up_filled0 as "icon--thumb-up-filled" }

const _icon__download0 = classes["icon--download"]
export { _icon__download0 as "icon--download" }
